import { Navigate, useRoutes, Route } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
import Login from './pages/Login';
import Register from './pages/Register';
import Devices from './pages/Devices';
import NotFound from './pages/Page404';
import ComingSoon from './pages/ComingSoon';
import SmartLockDashboard from './pages/SmartLockDashboard';
import Routes from './pages/Routes';
import SmartLockTrip from './pages/SmartLockTrips';
import TripDetails from './pages/TripDetails';
import VehiclesSmartLock from './pages/VehiclesSmartLock';
import SmartlockControlCenter from './pages/SmartLockControlCenter';
import Users from './pages/Users';
import UserActivity from './pages/UserActivity';

import { useAuth } from './components/customContextProviders/AuthContext';
import DeviceReport from './pages/DeviceReport';
import ForgetPassword from './pages/ForgetPassword';
import ChangePassword from './pages/ChangePassword';
import TicketManagement from './pages/TicketManagement';
import { URL_CONSTANT } from './URLConstants';
import FotaLogs from './pages/FotaLogs';

export const useAuthCheck = () => {
  const { sessionUserData } = useAuth();
  return {
    isAuthenticated: !!sessionUserData,
    sessionUserData
  };
};

// ----------------------------------------------------------------------

export default function Router() {
  const { isAuthenticated } = useAuthCheck();

  return useRoutes([
    {
      path: URL_CONSTANT.DASHBOARD,
      element: isAuthenticated ? <DashboardLayout /> : <Navigate to="/login" replace />,
      children: [
        { element: <Navigate to={URL_CONSTANT.SMARTLOCK} replace /> },
        { path: 'devices', element: <Devices /> },
        { path: 'smartlock', element: <SmartLockDashboard /> },
        { path: 'routes', element: <Routes /> },
        { path: 'trips', element: <SmartLockTrip /> },
        { path: 'vehicle', element: <VehiclesSmartLock /> },
        { path: 'tripdetails', element: <TripDetails /> },
        { path: 'smartlockControlCenter', element: <SmartlockControlCenter /> },
        { path: 'userManagement', element: <Users /> },
        { path: 'deviceReport', element: <DeviceReport /> },
        { path: 'activitylogs', element: <UserActivity /> },
        { path: 'ticketManagement', element: <TicketManagement /> },
        { path: 'fotalogsManagement', element: <FotaLogs /> }
      ]
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: 'login', element: <Login /> },
        { path: 'register', element: <Register /> },
        { path: 'forgot_password', element: <ForgetPassword /> },
        { path: 'password-change/:otp', element: <ChangePassword /> },
        { path: '404', element: <NotFound /> },
        { path: 'comingsoon', element: <ComingSoon /> },
        {
          path: '/',
          element: isAuthenticated ? (
            <Navigate to={URL_CONSTANT.SMARTLOCK} replace />
          ) : (
            <Navigate to="/login" replace />
          )
        },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}
